<div class="meet-content--main-column">
  @if (meet) {
    <footer class="d-flex justify-content-center footer--bottom-buttons">
      <ul class="nav nav-pills mb-auto text-center d-flex flex-nowrap flex-grow-1">
        <!-- Home -->
        <li class="nav-item flex-grow-1">
          <a
            routerLink="/meets/{{ meet.id }}"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="nav-link"
          >
            <span class="d-flex flex-column">
              <fa-icon [icon]="environment.icons.home" [fixedWidth]="true"></fa-icon>
              <div i18n="Home Tab Title on the Footer@@footer.homeTabTitle">Home</div>
            </span>
          </a>
        </li>
        <!-- Events -->
        <li class="nav-item flex-grow-1">
          <a routerLink="/meets/{{ meet.id }}/events" routerLinkActive="active" class="nav-link">
            <span class="d-flex flex-column">
              <fa-icon [icon]="environment.icons.events" [fixedWidth]="true"></fa-icon>
              <div i18n="Events Tab Title on the Footer@@footer.eventsTabTitle">Events</div>
            </span>
          </a>
        </li>
        <!-- Live -->
        @if (meet.allowScoreboard || meet.allowFieldScoreboard) {
          <li class="nav-item flex-grow-1">
            <a routerLink="/meets/{{ meet.id }}/live" routerLinkActive="active" class="nav-link">
              <span class="d-flex flex-column">
                <fa-icon [icon]="environment.icons.live" [fixedWidth]="true"></fa-icon>
                <div i18n="Live Tab Title on the Footer@@footer.liveTabTitle">Live</div>
              </span>
            </a>
          </li>
        }
        <!-- Scores -->
        @if (meet.scoreMeet && meet.meetScores) {
          @if (meet.sport !== 'xc') {
            <li class="nav-item flex-grow-1">
              <a routerLink="/meets/{{ meet.id }}/track-scores" routerLinkActive="active" class="nav-link">
                <span class="d-flex flex-column">
                  <fa-icon [icon]="environment.icons.scores" [fixedWidth]="true"></fa-icon>
                  <div i18n="Scores Tab Title on the Footer@@footer.scoresTabTitle">Scores</div>
                </span>
              </a>
            </li>
          }
        } @else if (meet.athleticNetId) {
          <li class="nav-item flex-grow-1">
            <a routerLink="/meets/{{ meet.id }}/follow" routerLinkActive="active" class="nav-link">
              <span class="d-flex flex-column">
                <fa-icon [icon]="environment.icons.followOn" [fixedWidth]="true"></fa-icon>
                <div i18n="Following Tab Title on the Footer@@footer.followingTabTitle">Following</div>
              </span>
            </a>
          </li>
        }
        <!-- Following -->
        <!-- Teams -->
        <!--
      <li class="flex-grow-1">
        <a routerLink="/meets/{{meet.id}}/teams" routerLinkActive="active" class="nav-link">
          <span class="d-flex flex-column">
            <fa-icon [icon]="environment.icons.teams" [fixedWidth]="true"></fa-icon>
            <div>Teams</div>
          </span>
        </a>
      </li>
      -->
        <!-- Athletes -->
        <!--
      <li class="flex-grow-1">
        <a routerLink="/meets/{{meet.id}}/athletes" routerLinkActive="active" class="nav-link">
          <span class="d-flex flex-column">
            <fa-icon [icon]="environment.icons.athletes" [fixedWidth]="true"></fa-icon>
            <div>Athletes</div>
          </span>
        </a>
      </li>
      -->
        <!-- More -->
        <li class="flex-grow-1">
          <a [routerLink]="" (click)="isSidebarOpenService.toggleSidebar()" class="nav-link">
            <span class="d-flex flex-column">
              <fa-icon [icon]="environment.icons.more" [fixedWidth]="true"></fa-icon>
              <div i18n="More Tab Title on the Footer@@footer.moreTabTitle2">More</div>
            </span>
          </a>
        </li>
      </ul>
    </footer>
  }
</div>
